export const calcMinuteHeight = (cellHeight, step) => {
  return Math.ceil(cellHeight) / step;
};

export const calcCellHeight = (tableHeight, hoursLength) => {
  return Math.max(tableHeight / hoursLength, 60);
};
